/**
 * Verknüpfungen zu externen Kartendiensten.
 *
 * Eine Position „daneben genauer ansehen" heißt in der Praxis: dieselbe
 * Koordinate in Google Maps öffnen, wo Luftbild und Straßenansicht liegen.
 */

/**
 * Google-Maps-Adresse für eine Koordinate.
 *
 * Das offizielle URL-Schema (`search/?api=1`) öffnet auf dem Telefon die
 * Maps-App, im Browser die Website — mit einer Stecknadel am Punkt.
 */
export function googleMapsUrl(lat: number, lon: number): string {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
}
